import React, { useMemo } from "react";

// Subtle floating-leaves background. CSS-only, GPU friendly.
// Renders a small set of SVG leaves at low opacity, drifting slowly.

const Leaf = ({ color = "#B89760" }) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <path
      d="M16 2 C 22 8, 26 14, 16 30 C 6 14, 10 8, 16 2 Z"
      fill={color}
      opacity="0.85"
    />
    <path d="M16 4 L16 28" stroke={color} strokeOpacity="0.55" strokeWidth="0.6" />
    <path d="M16 10 L11 13 M16 14 L11 17 M16 18 L11 21" stroke={color} strokeOpacity="0.5" strokeWidth="0.4" />
    <path d="M16 10 L21 13 M16 14 L21 17 M16 18 L21 21" stroke={color} strokeOpacity="0.5" strokeWidth="0.4" />
  </svg>
);

const PALETTE = ["#B89760", "#6B2D31", "#687059", "#A56A3A", "#8A5A2F"];

const FallingLeaves = ({ count = 12 }) => {
  const leaves = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const left = Math.random() * 100; // %
        const size = 10 + Math.random() * 18; // px
        const duration = 16 + Math.random() * 18; // s
        const delay = -Math.random() * duration; // negative so they're already mid-fall
        const swayDuration = 4 + Math.random() * 4; // s
        const rotation = Math.random() * 360;
        const opacity = 0.35 + Math.random() * 0.3; // 0.35–0.65 — visible pero sutil
        const color = PALETTE[i % PALETTE.length];
        return { left, size, duration, delay, swayDuration, rotation, opacity, color, id: i };
      }),
    [count]
  );

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-40 overflow-hidden"
      data-testid="falling-leaves"
    >
      {leaves.map((l) => (
        <span
          key={l.id}
          className="absolute top-[-40px] block animate-leaf-fall"
          style={{
            left: `${l.left}%`,
            width: `${l.size}px`,
            height: `${l.size}px`,
            opacity: l.opacity,
            animationDuration: `${l.duration}s`,
            animationDelay: `${l.delay}s`,
          }}
        >
          <span
            className="block w-full h-full animate-leaf-sway"
            style={{
              animationDuration: `${l.swayDuration}s`,
              transform: `rotate(${l.rotation}deg)`,
            }}
          >
            <Leaf color={l.color} />
          </span>
        </span>
      ))}
    </div>
  );
};

export default FallingLeaves;
